var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "Tabs",
        [
          _c(
            "Tab",
            { attrs: { name: "Información General", selected: "true" } },
            [
              _c("SerieNumeroFormGeneral", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Detalle de Preparación" } },
            [
              _c("SerieNumeroFormSerieActiva", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado,
                  serieactivanroSeleccionado: _vm.serieactivanroSeleccionado
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Devolución a Bodega" } },
            [
              _c("SerieNumeroFormDevolucionBodega", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado,
                  serieactivanroSeleccionado: _vm.serieactivanroSeleccionado
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Historial de Dispositivos" } },
            [
              _c("SerieNumeroFormMovimientoDispositivos", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }